/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Uno_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "The Uno assistant is now available to organisation members." |
*
* @param {Audit_Details_Uno_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_uno_enabled_desc = /** @type {((inputs?: Audit_Details_Uno_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Uno_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Uno-Assistent steht den Mitgliedern der Organisation jetzt zur Verfügung.")
	return /** @type {LocalizedString} */ ("The Uno assistant is now available to organisation members.")
});